var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-withdrawal-details",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px;`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow05.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.mybean.details"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "time-box" }, [
          _c(
            "div",
            { staticClass: "time-btn", on: { click: _vm.handleTimePop } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.handleMoment(_vm.chooseTime, "YYYY-MM"))),
              ]),
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/common/arrow06.png"),
                  alt: "",
                },
              }),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "list-wrapper" },
          [
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "loading-wrapper" },
                  [_c("van-loading")],
                  1
                )
              : _vm._l(_vm.details, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "list-item",
                      on: {
                        click: function ($event) {
                          return _vm.handleToStatusDetails(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "logo-wrapper" }, [
                        _c("img", {
                          attrs: {
                            src: _vm._f("imgPath")(item.withdrawalMethodIcon),
                            alt: "logo",
                            width: "40",
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "left-info-wrapper" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v(_vm._s(item.withdrawalMethod || "")),
                        ]),
                        _c("p", { staticClass: "date" }, [
                          _vm._v(
                            _vm._s(
                              _vm.handleMoment(
                                item.createTime,
                                "DD/MM HH:mm:ss"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "space" }),
                      _c("div", { staticClass: "right-info-wrapper" }, [
                        _c("div", { staticClass: "coins-wrapper" }, [
                          _c("span", [_vm._v(_vm._s(item.beansAmount))]),
                          _c("img", {
                            staticClass: "beans",
                            attrs: {
                              src: _vm.getMatchImg("beans"),
                              alt: "icon",
                              width: "16",
                              height: "16",
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "status-wrapper" }, [
                          _c(
                            "i",
                            { class: _vm.withdrawStatusClass(item.state) },
                            [_vm._v(_vm._s(_vm.withdrawStatusTxt(item.state)))]
                          ),
                        ]),
                      ]),
                      _vm._m(0, true),
                    ]
                  )
                }),
          ],
          2
        ),
      ]),
      _c("CTime", {
        attrs: { showPop: _vm.showPop },
        on: { handleCurrentDate: _vm.handleCurrentDate },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "more-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/more.png"),
          alt: "icon",
          width: "12",
          height: "12",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }